var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvalidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 8918",
    x: 2.23913,
    y: 1.73913,
    width: 36.5217,
    height: 36.5217,
    rx: 1.73913,
    stroke: "#292829",
    strokeWidth: 3.47826
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 3",
    x1: 10.5721,
    y1: 19.9275,
    x2: 30.4272,
    y2: 19.9275,
    stroke: "#292829",
    strokeWidth: 3.47826,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 4",
    x1: 15.5721,
    y1: 24.9275,
    x2: 25.4272,
    y2: 24.9275,
    stroke: "#292829",
    strokeWidth: 3.47826,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 5",
    x1: 15.5721,
    y1: 14.9275,
    x2: 25.4272,
    y2: 14.9275,
    stroke: "#292829",
    strokeWidth: 3.47826,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidIcon);
export default __webpack_public_path__ + "static/media/invalid-icon.371c180ceff4dc66f2e24099b2460f3e.svg";
export { ForwardRef as ReactComponent };